import { render, staticRenderFns } from "./AgreementRules.vue?vue&type=template&id=18beeebe&scoped=true&"
import script from "./AgreementRules.vue?vue&type=script&lang=js&"
export * from "./AgreementRules.vue?vue&type=script&lang=js&"
import style0 from "./AgreementRules.vue?vue&type=style&index=0&id=18beeebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18beeebe",
  null
  
)

export default component.exports